module.exports = __webpack_public_path__ + "img/plan2.0f0bfa0.webp";